'use strict';

var _classCallCheck = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _isNativeReflectConstruct = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/isNativeReflectConstruct");
var _getPrototypeOf = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
var Mixin = require('../../utils/mixin');
var LocationInfoOpenElementStackMixin = /*#__PURE__*/function (_Mixin) {
  function LocationInfoOpenElementStackMixin(stack, opts) {
    var _this;
    _classCallCheck(this, LocationInfoOpenElementStackMixin);
    _this = _callSuper(this, LocationInfoOpenElementStackMixin, [stack]);
    _this.onItemPop = opts.onItemPop;
    return _this;
  }
  _inherits(LocationInfoOpenElementStackMixin, _Mixin);
  return _createClass(LocationInfoOpenElementStackMixin, [{
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      return {
        pop: function pop() {
          mxn.onItemPop(this.current);
          orig.pop.call(this);
        },
        popAllUpToHtmlElement: function popAllUpToHtmlElement() {
          for (var i = this.stackTop; i > 0; i--) {
            mxn.onItemPop(this.items[i]);
          }
          orig.popAllUpToHtmlElement.call(this);
        },
        remove: function remove(element) {
          mxn.onItemPop(this.current);
          orig.remove.call(this, element);
        }
      };
    }
  }]);
}(Mixin);
module.exports = LocationInfoOpenElementStackMixin;